import { render, staticRenderFns } from "./TenantPage.vue?vue&type=template&id=1d98c19c&scoped=true&"
import script from "./TenantPage.vue?vue&type=script&lang=js&"
export * from "./TenantPage.vue?vue&type=script&lang=js&"
import style0 from "./TenantPage.vue?vue&type=style&index=0&id=1d98c19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98c19c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d98c19c')) {
      api.createRecord('1d98c19c', component.options)
    } else {
      api.reload('1d98c19c', component.options)
    }
    module.hot.accept("./TenantPage.vue?vue&type=template&id=1d98c19c&scoped=true&", function () {
      api.rerender('1d98c19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/TenantPage.vue"
export default component.exports